<!-- Insurance Invoice Format -->
<div class="ins-inv-container">
  <div class="ins-inv-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header -->
    <div class="ins-header">
      <div class="header-logo">
        <div class="logo-circle">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo"
            style="width: 100%; height: 100%; object-fit: contain;">
          <span *ngIf="!logoUrl" class="logo-text">SMJ</span>
        </div>
      </div>
      <div class="header-company">
        <h2 class="company-name">{{ settings?.company }}</h2>
        <p>{{ settings?.city }}, {{ settings?.state }}, JAPAN</p>
        <p>TEL: {{ settings?.telephone }} &nbsp; FAX: {{ settings?.fax }}</p>
        <p>EMAIL: {{ settings?.email_1 }}</p>
      </div>
    </div>

    <!-- Consignee + Invoice Details Row -->
    <div class="main-top-row">
      <div class="consignee-block">
        <div class="block-label">CONSIGNEE:</div>
        <div class="block-content">
          <p><strong>{{ invoice.order?.buyer_company_name }}</strong></p>
          <p>{{ invoice.order?.buyer_street_address }}</p>
          <p>TEL: {{ invoice.order?.buyer_telephone_no }}</p>
          <p>{{ invoice.order?.buyer_city }}</p>
          <p>{{ invoice.order?.buyer_country }}</p>
          <p>NOTIFY PARTY: {{ invoice.order?.notify_party_name || invoice.order?.notify_party_company || '-' }}</p>
        </div>
      </div>
      <div class="invoice-meta-block">
        <table class="meta-table">
          <tr>
            <td class="meta-label">INVOICE NO:</td>
            <td class="meta-value"><strong>{{ invoice.invoice_number }}</strong></td>
          </tr>
          <tr>
            <td class="meta-label">DATE:</td>
            <td class="meta-value">{{ formatDate(invoice.invoice_date) }}</td>
          </tr>
        </table>
        <div class="bank-details">
          <div class="bank-header">BANK DETAILS</div>
          <div class="bank-row">
            <span class="bank-label">BANK NAME:</span>
            <input class="bank-input" [(ngModel)]="bankName">
          </div>
          <div class="bank-row">
            <span class="bank-label">BRANCH:</span>
            <input class="bank-input" [(ngModel)]="branchName">
          </div>
          <div class="bank-row">
            <span class="bank-label">ACCT NAME:</span>
            <input class="bank-input" [(ngModel)]="accountName">
          </div>
          <div class="bank-row">
            <span class="bank-label">ACCT NO:</span>
            <input class="bank-input" [(ngModel)]="accountNo">
          </div>
          <div class="bank-row">
            <span class="bank-label">SWIFT:</span>
            <input class="bank-input" [(ngModel)]="swiftCode">
          </div>
        </div>
      </div>
    </div>

    <!-- Port & Ship Info -->
    <div class="port-ship-block">
      <p><strong>PORT OF LOADING:</strong> {{ invoice.ship?.sailing_port || '-' }}</p>
      <p><strong>PORT OF DISCHARGING:</strong> {{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</p>
    </div>
    <div class="ship-block">
      <p><strong>SHIPPED PER:</strong> {{ invoice.ship?.name || '-' }} &nbsp;&nbsp; <strong>VOYAGE NO:</strong> {{ invoice.ship?.voyage_no || '-' }}</p>
      <p><strong>SHIP TYPE:</strong> {{ invoice.order?.ship_type || 'CONTAINER' }}</p>
    </div>
    <div class="terms-block">
      <p><strong>ETD:</strong> {{ formatDate(invoice.ship?.sailing_date) }} &nbsp;&nbsp; <strong>TRADE TERMS:</strong> {{ invoice.order?.payment_terms || 'DA AT SIGHT' }}</p>
      <p><strong>ETA:</strong> {{ formatDate(invoice.ship?.arrival_date) }} &nbsp;&nbsp; <strong>PAYMENT TERMS:</strong> {{ invoice.order?.payment_terms || '-' }}</p>
    </div>

    <!-- Vehicle(s) Table -->
    <table class="vehicle-table">
      <thead>
        <tr>
          <th class="col-img">IMAGE</th>
          <th class="col-details">VEHICLE DETAILS</th>
          <th class="col-cost">COST ($)</th>
        </tr>
      </thead>
      <tbody>
        <!-- Individual mode -->
        <ng-container *ngIf="viewMode !== 'merged' || !invoice.vehicles">
          <tr>
            <td class="col-img">
              <img
                [src]="invoice.vehicle?.pictures && invoice.vehicle.pictures.length > 0 ? invoice.vehicle.pictures[0] : 'assets/images/no-car-image.png'"
                [alt]="invoice.vehicle?.make + ' ' + invoice.vehicle?.model"
                class="vehicle-img">
            </td>
            <td class="col-details">
              <p><strong>{{ invoice.vehicle?.make }} {{ invoice.vehicle?.model }}</strong></p>
              <p>MFG YEAR: {{ formatMfgYear(invoice.vehicle?.year, invoice.vehicle?.month) }}</p>
              <p>CHASSIS NO: {{ invoice.vehicle?.chassis_no || '-' }}</p>
              <p>ENGINE: {{ invoice.vehicle?.engine || '-' }}</p>
              <p>MILEAGE: {{ invoice.vehicle?.mileage | number }} KM</p>
              <p>STOCK: {{ invoice.vehicle?.car_no || '-' }} &nbsp; WT: {{ invoice.vehicle?.weight || invoice.vehicle?.car_weight || '-' }}</p>
              <p>FUEL: {{ invoice.vehicle?.fuel_type || '-' }} &nbsp; COLOR: {{ invoice.vehicle?.exterior_color || '-' }}</p>
              <p>TRANS: {{ invoice.vehicle?.transmission || '-' }}</p>
            </td>
            <td class="col-cost">
              <p class="cost-label">1 UNIT PRICE:</p>
              <p class="cost-value">${{ invoice.invoice_amount | number:'1.2-2' }}</p>
            </td>
          </tr>
        </ng-container>

        <!-- Merged mode -->
        <ng-container *ngIf="viewMode === 'merged' && invoice.vehicles">
          <tr *ngFor="let vehicle of invoice.vehicles; let vi = index">
            <td class="col-img">
              <img
                [src]="vehicle.pictures && vehicle.pictures.length > 0 ? vehicle.pictures[0] : 'assets/images/no-car-image.png'"
                [alt]="vehicle.make + ' ' + vehicle.model"
                class="vehicle-img">
            </td>
            <td class="col-details">
              <p><strong>{{ vehicle.make }} {{ vehicle.model }}</strong></p>
              <p>MFG YEAR: {{ formatMfgYear(vehicle.year, vehicle.month) }}</p>
              <p>CHASSIS NO: {{ vehicle.chassis_no || '-' }}</p>
              <p>ENGINE: {{ vehicle.engine || '-' }}</p>
              <p>MILEAGE: {{ vehicle.mileage | number }} KM</p>
              <p>STOCK: {{ vehicle.car_no || '-' }} &nbsp; WT: {{ vehicle.weight || vehicle.car_weight || '-' }}</p>
              <p>FUEL: {{ vehicle.fuel_type || '-' }} &nbsp; COLOR: {{ vehicle.exterior_color || '-' }}</p>
              <p>TRANS: {{ vehicle.transmission || '-' }}</p>
            </td>
            <td class="col-cost">
              <p class="cost-label">1 UNIT PRICE:</p>
              <p class="cost-value">${{ vehicle.invoice_amount | number:'1.2-2' }}</p>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td colspan="2">
            TOTAL {{ getUnitCount(invoice) }} UNIT(S)
          </td>
          <td>
            <p>TOTAL ${{ invoice.invoice_amount | number:'1.2-2' }}</p>
            <p>GRAND ${{ invoice.invoice_amount | number:'1.2-2' }}</p>
          </td>
        </tr>
      </tfoot>
    </table>

    <!-- Footer -->
    <div class="inv-footer">
      <div class="footer-left">
        <p><strong>DUE DATE *</strong> {{ invoice.payment_due_date ? formatDate(invoice.payment_due_date) : '' }}</p>
        <div class="footer-note">
          <strong>NOTE:</strong>
          PLEASE INCLUDE PROFORMA NUMBERS IN THE REMITTANCE INFORMATION SECTION WHEN MAKING YOUR PAYMENT.
          WE CERTIFY THAT THE GOODS ARE OF JAPANESE ORIGIN. THE BUYER SHOULD BEAR THE COST OF BANK CHARGE WHEN REMITTING T/T.
          THE BUYER IS PURCHASING A RECONDITIONED VEHICLE. MINOR ISSUES SUCH AS WEAK BATTERY, LACK OF COOLANT, MINOR SCRATCHES,
          DENTS, WORN TIRES, MINOR ELECTRICAL ISSUES ARE NOT COVERED UNDER WARRANTY.
        </div>
      </div>
      <div class="footer-sig">
        <div class="stamp-box">[STAMP]</div>
        <p class="sig-label">AUTHORIZED SIGNATURE</p>
        <p><strong>{{ settings?.company }}</strong></p>
      </div>
    </div>

    <!-- Page Break -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
